import React from "react";

const TitleSub = props => {
    return (
        <React.Fragment>
            <hr />
            <h2 className="paragraph_subtitle text-center">{props.title}</h2>
        </React.Fragment>
    ) 
}

export default TitleSub;
